import { IJustifyPositionProps } from 'types/components/components.interface';
import './InputMessage.scss';

interface IInputMessageProps extends IJustifyPositionProps {
  message?: string;
  helperText?: string;
}

const InputMessage: React.FC<IInputMessageProps> = ({
  helperText,
  message,
  justifyPosition,
}) => {
  return (
    <div className='input-message-portal'>
      <div className='input-message'>
        {message && <span className='error'>{message}</span>}
        {helperText && <span className='helper'>{helperText}</span>}
      </div>
    </div>
  );
};

export default InputMessage;
